var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h1", [
      _vm._v(
        " " +
          _vm._s(
            _vm.user.id != null
              ? _vm.$t("settings.users.userEdit")
              : _vm.$t("settings.users.userNew")
          ) +
          " "
      )
    ]),
    _c(
      "div",
      { staticClass: "mt-3 elevation-12 grey lighten-4" },
      [
        _c("user-settings-menu"),
        _c(
          "v-card",
          [
            _c(
              "v-card-text",
              [
                _c(
                  "v-form",
                  {
                    ref: "form",
                    attrs: { "lazy-validation": "" },
                    model: {
                      value: _vm.formValid,
                      callback: function($$v) {
                        _vm.formValid = $$v
                      },
                      expression: "formValid"
                    }
                  },
                  [
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t(
                          "settings.users.delegationData.fields.integrationIdentifier.name"
                        )
                      },
                      model: {
                        value: _vm.user.integration_identifier,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "integration_identifier", $$v)
                        },
                        expression: "user.integration_identifier"
                      }
                    }),
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.availableSuperiors,
                        label: _vm.$t(
                          "settings.users.delegationData.fields.superiorUser.name"
                        )
                      },
                      model: {
                        value: _vm.user.superior_user_id,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "superior_user_id", $$v)
                        },
                        expression: "user.superior_user_id"
                      }
                    }),
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.availableOrganisationStructures,
                        label: _vm.$t(
                          "settings.users.delegationData.fields.organizationStructure.name"
                        )
                      },
                      model: {
                        value: _vm.user.organization_structure_id,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "organization_structure_id", $$v)
                        },
                        expression: "user.organization_structure_id"
                      }
                    }),
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.availablePrivateVehicles,
                        label: _vm.$t(
                          "settings.users.delegationData.fields.privateVehicle.name"
                        )
                      },
                      model: {
                        value: _vm.user.vehicle_private_id,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "vehicle_private_id", $$v)
                        },
                        expression: "user.vehicle_private_id"
                      }
                    }),
                    _c("v-autocomplete", {
                      attrs: {
                        items: _vm.availableDefaultVehicles,
                        label: _vm.$t(
                          "settings.users.delegationData.fields.defaultVehicle.name"
                        )
                      },
                      model: {
                        value: _vm.user.vehicle_default_id,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "vehicle_default_id", $$v)
                        },
                        expression: "user.vehicle_default_id"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t(
                          "settings.users.delegationData.fields.bankName.name"
                        )
                      },
                      model: {
                        value: _vm.user.bank_name,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "bank_name", $$v)
                        },
                        expression: "user.bank_name"
                      }
                    }),
                    _c("v-text-field", {
                      attrs: {
                        label: _vm.$t(
                          "settings.users.delegationData.fields.bankAccount.name"
                        )
                      },
                      model: {
                        value: _vm.user.bank_account_number,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "bank_account_number", $$v)
                        },
                        expression: "user.bank_account_number"
                      }
                    }),
                    _c("location-ajax-select", {
                      attrs: {
                        label: _vm.$t("global.homeLocation"),
                        placeholder: _vm.user.home_address_name,
                        "select-model": _vm.user.home_address_id
                      },
                      on: {
                        "update:selectModel": function($event) {
                          return _vm.$set(_vm.user, "home_address_id", $event)
                        },
                        "update:select-model": function($event) {
                          return _vm.$set(_vm.user, "home_address_id", $event)
                        }
                      }
                    }),
                    _c("location-ajax-select", {
                      attrs: {
                        label: _vm.$t("global.workLocation"),
                        placeholder: _vm.user.work_address_name,
                        "select-model": _vm.user.work_address_id
                      },
                      on: {
                        "update:selectModel": function($event) {
                          return _vm.$set(_vm.user, "work_address_id", $event)
                        },
                        "update:select-model": function($event) {
                          return _vm.$set(_vm.user, "work_address_id", $event)
                        }
                      }
                    }),
                    _c("v-autocomplete", {
                      attrs: {
                        clearable: true,
                        items: _vm.availableDelegationGroups,
                        label: _vm.$t(
                          "settings.users.delegationData.fields.delegationRateGroup.name"
                        )
                      },
                      model: {
                        value: _vm.user.group_id,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "group_id", $$v)
                        },
                        expression: "user.group_id"
                      }
                    }),
                    _c("v-select", {
                      attrs: {
                        items: _vm.languageChooser,
                        label: _vm.$t(
                          "settings.users.delegationData.fields.language.name"
                        )
                      },
                      model: {
                        value: _vm.user.language,
                        callback: function($$v) {
                          _vm.$set(_vm.user, "language", $$v)
                        },
                        expression: "user.language"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-card",
          [
            _c(
              "v-card-actions",
              [
                _c("v-spacer"),
                _c(
                  "v-btn",
                  {
                    attrs: { color: "blue darken-1", text: "" },
                    nativeOn: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.cancel")))]
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      disabled:
                        !_vm.formValid || _vm.$store.getters["Ajax/loading"],
                      color: "blue darken-1",
                      text: ""
                    },
                    on: {
                      click: function($event) {
                        return _vm.save()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("global.save")) + " ")]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }